import CrudService from "../common/CrudService";
import api from "../api";

class BookingService extends CrudService {
  get endpoint() {
    return "/api/bookings";
  }

  async cancelBooking(bookingId) {
    return api.get(`${this.endpoint}/cancel/${bookingId}`);
  }
}

export default new BookingService();
